<section class="fj-resource-cover fj-resource-hero-search" appHeroScrollCue>
    <div class="site-container fj-resource-cover-grid fj-resource-search-layout">
        <div class="fj-resource-hero-heading">
            <h1>Find a recommended local service contact.</h1>
        </div>

        <div class="fj-resource-results fj-resource-hero-results">
            <div class="resource-control-strip fj-resource-search fj-resource-search-panel">
                <label class="resource-control-field resource-search-field">
                    <span>Search providers</span>
                    <input type="search" [value]="searchTerm" (input)="updateSearch($event)"
                        aria-label="Search providers"
                        placeholder="Search issue, service, business, name, phone" />
                </label>

                <div class="resource-control-field resource-service-field resource-service-menu"
                    [class.is-open]="serviceDropdownOpen">
                    <span>Service type</span>
                    <button type="button" class="resource-service-trigger" (click)="toggleServiceDropdown()"
                        aria-haspopup="listbox" [attr.aria-expanded]="serviceDropdownOpen"
                        [style.background]="serviceBackground(selectedCategory)"
                        [style.color]="serviceTextColor(selectedCategory)">
                        <span>{{ serviceOptionLabel(selectedCategory) }}</span>
                        <small>{{ selectedCategory === 'All' ? resources.length : categoryCounts[selectedCategory] }} contacts</small>
                        <i aria-hidden="true">v</i>
                    </button>

                    <div class="resource-service-options" *ngIf="serviceDropdownOpen" role="listbox"
                        aria-label="Filter providers by service type">
                        <button *ngFor="let category of categories" type="button" role="option"
                            [attr.aria-selected]="category === selectedCategory"
                            (click)="selectCategoryFromDropdown(category)"
                            [style.background]="serviceBackground(category)"
                            [style.color]="serviceTextColor(category)">
                            <span>{{ serviceOptionLabel(category) }}</span>
                            <small>{{ category === 'All' ? resources.length : categoryCounts[category] }} contacts</small>
                        </button>
                    </div>
                </div>
            </div>

            <div class="fj-active-resource-strip" aria-label="Active provider filters" aria-live="polite">
                <span>{{ serviceOptionLabel(selectedCategory) }}</span>
                <span *ngIf="trimmedSearchTerm">Search: {{ trimmedSearchTerm }}</span>
                <span>{{ activeSummary }}</span>
                <span>{{ pageSummary }}</span>
            </div>

            <section class="fj-provider-table" *ngIf="filteredResources.length > 0" aria-label="Filtered provider contacts">
                <div class="fj-provider-card-grid">
                    <article *ngFor="let resource of pagedResources" class="fj-provider-card">
                        <div class="fj-provider-card-head">
                            <span class="resource-service-pill" [style.background]="serviceBackground(resource.category || 'All')"
                                [style.color]="serviceTextColor(resource.category || 'All')">
                                {{ serviceOptionLabel(resource.category || 'Provider') }}
                            </span>
                            <strong>{{ providerName(resource) }}</strong>
                        </div>
                        <dl>
                            <div *ngIf="hasContactName(resource)">
                                <dt>Contact</dt>
                                <dd>{{ contactLabel(resource) }}</dd>
                            </div>
                            <div>
                                <dt>Phone</dt>
                                <dd>{{ resource.phone || 'Contact details listed above' }}</dd>
                            </div>
                        </dl>
                        <div class="fj-provider-actions">
                            <a *ngIf="resource.phone" [href]="phoneHref(resource.phone)"
                                [attr.aria-label]="'Call ' + providerName(resource)">Call {{ resource.phone }}</a>
                            <a *ngIf="resource.email" href="mailto:{{resource.email}}">{{ resource.email }}</a>
                            <span *ngIf="!resource.phone && !resource.email">Verify details</span>
                        </div>
                    </article>
                </div>

                <nav class="fj-resource-pagination" *ngIf="hasMultiplePages" aria-label="Provider result pages">
                    <button type="button" (click)="previousPage()" [disabled]="clampedCurrentPage === 1">
                        Previous
                    </button>
                    <div>
                        <button *ngFor="let page of pageNumbers" type="button" (click)="setPage(page)"
                            [class.is-selected]="page === clampedCurrentPage"
                            [attr.aria-current]="page === clampedCurrentPage ? 'page' : null">
                            {{ page }}
                        </button>
                    </div>
                    <button type="button" (click)="nextPage()" [disabled]="clampedCurrentPage === totalPages">
                        Next
                    </button>
                </nav>
            </section>

            <div class="empty-resource-state" *ngIf="filteredResources.length === 0">
                <h3>No providers match those filters.</h3>
                <p>Try another search term or choose All services from the service menu.</p>
            </div>

            <div id="resources-disclaimer" class="fj-resource-disclaimer fj-resource-hero-disclaimer">
                <strong>Referral and resource disclaimer</strong>
                <p>
                    These provider contacts are informational starting points only. GTX Inspections does not guarantee work
                    quality, availability, pricing, licensing, insurance, or fit.
                </p>
            </div>
        </div>
    </div>
</section>
